import { useContext } from 'react'
import { Link as RouterLink } from 'react-router'
import { Box, Grid, Link, Typography } from '@mui/material'

import StatusChip from '../../../components/status-chip'
import { AppContext } from '../../../providers/app-provider'
import useSharedStyles from '../../../utils/shared.styles'
import getUseCaseMatrix from '../../../utils/usecase-matrix'
import useStyles from '../index.styles'

const DeviceHeader = ({ device }: { device: IDeviceAPIObject }) => {
  const classes = useStyles
  const sharedClasses = useSharedStyles
  const { id, folderName, accountStatus, vanity, deviceStatus, firmwareVersion, deviceUsecase, folderId } = device
  const { tenantId } = useContext(AppContext)

  const mainTextColor = deviceStatus === 'Deactivated' ? 'textSecondary' : 'textPrimary'

  return (
    <Grid
      container={true}
      data-testid="device-header"
      size={12}
      sx={{
        my: 4,
      }}
    >
      <Grid container={true} spacing={2} size={12} sx={sharedClasses.centerContentVertical}>
        <Grid>
          <Link component={RouterLink} to={`/tenant/${tenantId}/accounts/${folderId}?tab=devices`} underline="hover" aria-label="Go to Account">
            <Typography variant="h5">{folderName}</Typography>
          </Link>
        </Grid>

        {accountStatus && (
          <Grid>
            <StatusChip label={accountStatus} />
          </Grid>
        )}
      </Grid>
      <Grid container={true} size={12} spacing={2} sx={[sharedClasses.centerContentVertical, { mt: 1 }]}>
        <Grid>
          <Typography variant="h6">{vanity}</Typography>
        </Grid>

        <Grid>
          <StatusChip label={deviceStatus} />
        </Grid>

        {firmwareVersion && firmwareVersion !== '<nil>' && firmwareVersion !== '0' && (
          <Grid>
            <Box sx={classes.metaTag}>
              <Typography component="div" variant="caption" color={mainTextColor} data-testid="firmware-metaTag">
                v{firmwareVersion}
              </Typography>
            </Box>
          </Grid>
        )}

        <Grid>
          <Box sx={classes.metaTag}>
            <Typography variant="caption" color={mainTextColor}>
              {getUseCaseMatrix()[deviceUsecase]}
            </Typography>
          </Box>
        </Grid>

        <Grid>
          <Typography variant="body1" sx={sharedClasses.secondaryText}>
            Node ID: {id}
          </Typography>
        </Grid>
      </Grid>
    </Grid>
  )
}

export default DeviceHeader
